module.exports = __webpack_public_path__ + "img/pass.0791b746.png";